const PinLine = ({ className = '', ...props }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M7.08425 1.23926L11.3272 5.48226L10.6198 6.18926L10.2662 5.83576L8.14525 7.95676L7.79175 9.72476L7.08425 10.4318L4.96325 8.31026L2.48825 10.7853L1.78125 10.0783L4.25625 7.60326L2.13475 5.48226L2.84175 4.77476L4.61025 4.42126L6.73125 2.30026L6.37775 1.94676L7.08475 1.23926H7.08425ZM7.43825 3.00726L5.10275 5.34226L3.69175 5.62476L6.94175 8.87476L7.22375 7.46376L9.55925 5.12876L7.43825 3.00726Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default PinLine;
